import React, { useEffect, useState, useContext } from "react";
import {FormControlLabel, Popover, Checkbox
  } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import FilterAltTwoToneIcon from '@mui/icons-material/FilterAltTwoTone';
import {
    setState,
} from "./defineSlice";

const SKUNumberPopOver = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const dispatch = useDispatch();
    const define = useSelector((state) => state.define);
    const { filter_skuName, filter_skuNumber,skuNumberList, SKUList, selectedProduct } = define;

    const handleCheckboxChange = (category) => {
        let val = filter_skuNumber.includes(category) ? filter_skuNumber.filter((c) => c !== category) : [...filter_skuNumber, category];
        dispatch(setState("filter_skuNumber", val));
        let skuName = SKUList?.filter((item) => item.skuNumber === category).map((item) => item.skuName);
        let filterRow = JSON.parse(JSON.stringify(filter_skuName));
        for(let i = 0; i< skuName.length; i++){
          filterRow = filterRow.includes(skuName[i]) ? filterRow.filter((c) => c !== skuName[i]) : [...filterRow, skuName[i]];
        }
        dispatch(setState("filter_skuName", filterRow));
    };
    const handleHeaderClick = (event) => {
        event.stopPropagation();
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };


    // useEffect(()=>{
    //     let skuName = SKUList?.filter((item) => filter_skuNumber.includes(item.skuNumber));
    //     let filterRow = JSON.parse(JSON.stringify(filter_skuName));
    //     for(let i = 0; i<skuName.length; i++){
    //         filterRow = filterRow.includes(skuName[i].skuName) ? filterRow.filter((c) => c !== skuName[i].skuName) : [...filterRow, skuName[i].skuName];
    //     }
    //     dispatch(setState("filter_skuName", filterRow));
    // },[filter_skuNumber]);

    const handleCloseTrust = () => {
        setAnchorEl(null);
    };

    return(
        <div>
        <div 
        style={{ display: 'flex', justifyContent: 'space-between', wordWrap: 'break-word', whiteSpace: 'pre-wrap', fontSize: '14px', cursor: 'pointer', lineHeight: '1.2' }}> 
        <span style = {{fontWeight:"700"}}>SKU Number{"  "}</span> 
        <div onClick={handleHeaderClick} >
        {filter_skuNumber?.length === 0 &&<FilterAltOutlinedIcon style={{ color: '#bcbcba', fontSize : '35px', paddingTop : '15px'}} />}
        {filter_skuNumber?.length > 0 && <FilterAltTwoToneIcon style={{ color: '#6f6f6c', fontSize : '35px', paddingTop : '15px'}} />}
        </div>
        </div>

        <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleCloseTrust}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }} 
        transformOrigin={{ vertical: 'top', horizontal: 'center', }}
        //anchorPosition={{ top: 50, left: -500 }}
      >
        <div style={{ padding: 16, maxHeight: '200px', overflowY: 'auto' }}>
          {skuNumberList?.map((item) => (
            <FormControlLabel
              control={
                <Checkbox
                  checked={filter_skuNumber.includes(item)}
                  onChange={() => handleCheckboxChange(item)}
                />
              }
              label={item}
              key={item}
              style={{ display: 'block' }}
            />
          ))}
        </div>
      </Popover>
      </div>
    );
}
export default SKUNumberPopOver;